/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Color } from 'three';
/**
 * colormaps to present special attributes (e.g. intensity)
 */
export class ColorMaps {
    /**
     * greates a new color palette
     *
     * @param model the color model (jet, hsv, rainbow ...)
     * @param size the size of the color palette
     * @param scale the max. value of one channel (for 8Bit per channel this is could be 255)
     */
    static generate(model, size, scale = 1) {
        const arr = new Array(size);
        for (let i = 0; i < size; i++) {
            arr[i] = this.getColorAt(i / (size - 1), model).multiplyScalar(scale);
        }
        return arr;
    }
    /**
     * returns the color value of the given model at a given position
     * @param p a value between 0 and 1
     * @param model the color model (jet, hsv,..)
     * @returns the color where each channel is a value between 0 and 1
     */
    static getColorAt(p, model) {
        let i = 0;
        let s = model[i++];
        while (i < model.length - 1 && model[i].p < p) {
            s = model[i];
            i++;
        }
        const e = model[i];
        const colorS = new Color();
        const colorE = new Color();
        colorS.fromArray(s.rgb);
        colorE.fromArray(e.rgb);
        const a = (p - s.p) / (e.p - s.p);
        return colorS.lerp(colorE, a);
    }
    static getModelByName(name) {
        let map = ColorMaps.models[name];
        if (map == null) {
            map = ColorMaps.models.jet; // default
        }
        return map;
    }
    static getModelByIndex(index) {
        let name = '';
        if (Object.getOwnPropertyNames(ColorMaps.models).length > index
            && index > -1) {
            name = Object.getOwnPropertyNames(ColorMaps.models)[index];
        }
        return this.getModelByName(name);
    }
}
ColorMaps.models = {
    jet: [{ p: 0, rgb: [0, 0, 0.5] }, { p: 0.125, rgb: [0, 0, 1] }, { p: 0.375, rgb: [0, 1, 1] },
        { p: 0.625, rgb: [1, 1, 0] }, { p: 0.875, rgb: [1, 0, 0] }, { p: 1, rgb: [0.5, 0, 0] }],
    hsv: [{ p: 0, rgb: [1, 0, 0] }, { p: 0.167, rgb: [1, 1, 0] }, { p: 0.33, rgb: [0, 1, 0] },
        { p: 0.5, rgb: [0, 1, 1] }, { p: 0.67, rgb: [0, 0, 1] }, { p: 0.83, rgb: [1, 0, 1] },
        { p: 1, rgb: [1, 0, 0] }],
    rainbow: [{ p: 0, rgb: [1, 0, 0] }, { p: 0.167, rgb: [1, 0, 1] }, { p: 0.33, rgb: [0, 0, 1] },
        { p: 0.5, rgb: [0, 1, 1] }, { p: 0.67, rgb: [0, 1, 0] }, { p: 0.83, rgb: [1, 1, 0] },
        { p: 1, rgb: [1, 0, 0] }],
    hot: [{ p: 0, rgb: [0, 0, 0] }, { p: 0.33, rgb: [1, 0, 0] }, { p: 0.66, rgb: [1, 1, 0] }, { p: 1, rgb: [1, 1, 1] }],
    cool: [{ p: 0, rgb: [0, 1, 1] }, { p: 1, rgb: [1, 0, 1] }],
    greys: [{ p: 0, rgb: [0, 0, 0] }, { p: 1, rgb: [1, 1, 1] }],
    spring: [{ p: 0, rgb: [1, 0, 1] }, { p: 1, rgb: [1, 1, 0] }],
    summer: [{ p: 0, rgb: [0, 0.5, 0.4] }, { p: 1, rgb: [1, 1, 0.4] }],
    autumn: [{ p: 0, rgb: [1, 0, 0] }, { p: 1, rgb: [1, 1, 0] }],
    winter: [{ p: 0, rgb: [0, 0, 1] }, { p: 1, rgb: [0, 1, 0.5] }],
    bluewhitered: [{ p: 0, rgb: [0, 0.1, 1] }, { p: 0.5, rgb: [1, 1, 1] }, { p: 1, rgb: [1, 0.1, 0] }],
};
//# sourceMappingURL=ColorMaps.js.map